import { render, staticRenderFns } from "./school-calendar-admin.vue?vue&type=template&id=19f9c65d&"
import script from "./school-calendar-admin.ts?vue&type=script&lang=ts&"
export * from "./school-calendar-admin.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports